export const DRAINS_BASE_PATH = '/drains';
export const RoutesList = {
  DRAINS_HOME: DRAINS_BASE_PATH,
  ISSUE_TYPE: DRAINS_BASE_PATH + '/issue',
  ISSUE_LOCATION: DRAINS_BASE_PATH + '/issue-location',
  CALL_US: DRAINS_BASE_PATH + '/call-us',
  THAMES_WATER: DRAINS_BASE_PATH + '/thames-water',
  CALLBACKS: DRAINS_BASE_PATH + '/callbacks/*',
  PRIVATE_PROPERTY_ISSUE: DRAINS_BASE_PATH + '/private-property-issue',
  UPLOAD_PHOTOS: DRAINS_BASE_PATH + '/upload-photos',
  REPORT_TO_PRIVATE_PROPERTY_OWNER:
    DRAINS_BASE_PATH + '/report-to-private-property-owner',
  FLOOD_AFFECTING: DRAINS_BASE_PATH + '/flood-affecting',
  DESCRIBE_ISSUE: DRAINS_BASE_PATH + '/describe-issue',
  LOCATION_ADDITIONAL_INFORMATION:
    DRAINS_BASE_PATH + '/location-additional-information',
  EMAIL_CONFIRMATION: DRAINS_BASE_PATH + '/email-confirmation',
  CONTACT_USER_OPTION: DRAINS_BASE_PATH + '/can-we-contact-you',
  YOUR_DETAILS: DRAINS_BASE_PATH + '/your-details',
  CONFIRMATION: DRAINS_BASE_PATH + '/confirmation',
  NOT_FOUND: '*',
  INTERNAL_SERVER_ERROR: DRAINS_BASE_PATH + '/500',
};

export const steps = [
  {
    label: 'Details ',
    urlPaths: [
      RoutesList.ISSUE_TYPE,
      RoutesList.PRIVATE_PROPERTY_ISSUE,
      RoutesList.FLOOD_AFFECTING,
      RoutesList.DESCRIBE_ISSUE,
    ],
  },
  {
    label: 'Photos',
    urlPaths: [RoutesList.UPLOAD_PHOTOS],
  },
  {
    label: 'Location',
    urlPaths: [
      RoutesList.LOCATION_ADDITIONAL_INFORMATION,
      RoutesList.ISSUE_LOCATION,
    ],
  },
  {
    label: 'Your details',
    urlPaths: [
      RoutesList.EMAIL_CONFIRMATION,
      RoutesList.CONTACT_USER_OPTION,
      RoutesList.YOUR_DETAILS,
    ],
  },
];
